import React from 'react';
import {
  Table, Dropdown, Icon, Popup,
} from 'semantic-ui-react';

import {
  STATUS,
  statusOf,
  isEditable,
  NOT_RESOLVING_GUIDANCE,
  SCHEDULED_GUIDANCE,
} from '../../constants/defaultCoverageMaster';

export const ACTION = { EDIT: 'Edit', END: 'End' };

const money = value => (value === null || value === undefined ? '' : `$${Number(value).toFixed(2)}`);
const dateOnly = value => (value ? String(value).slice(0, 10) : '');

// Colour carries the same states as the label, so a side's ladder is
// readable without reading every cell.
const STATUS_COLOR = {
  [STATUS.RESOLVING]: 'green',
  [STATUS.SCHEDULED]: 'blue',
  [STATUS.NOT_RESOLVING]: 'orange',
  [STATUS.ENDED]: 'grey',
};

const ListRow = actionHandler => defaultCoverageMaster => {
  const {
    id,
    productId,
    productCode,
    productName,
    startTs,
    endTs,
    priceDs,
  } = defaultCoverageMaster;

  const status = statusOf(defaultCoverageMaster);

  // An ended master offers no actions: there is nothing to change that would have
  // any effect, and re-ending would only move an end date that has already passed.
  const rowMenuOptions = isEditable(defaultCoverageMaster)
    ? [
      { key: 1, text: ACTION.EDIT, value: ACTION.EDIT },
      { key: 2, text: ACTION.END, value: ACTION.END },
    ]
    : [];

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, defaultCoverageMaster);
  };

  return (
    <Table.Row key={id} data-testid={`default-coverage-master-row-${id}`}>
      <Table.Cell>
        {productName ? `${productCode} - ${productName}` : productCode || productId}
      </Table.Cell>
      <Table.Cell>{money(priceDs)}</Table.Cell>
      <Table.Cell>{dateOnly(startTs)}</Table.Cell>
      <Table.Cell>{dateOnly(endTs)}</Table.Cell>
      <Table.Cell>
        <span data-testid={`default-coverage-master-status-${id}`}>{status}</span>
        {/* A live-but-not-resolving master looks identical to an active one on its
            own row - nothing in these cells explains it, so the reason is attached
            to the state itself rather than left for the operator to work out. */}
        {/* A scheduled master is live-but-not-resolving too, but only because
            its start is still ahead - an info note, not the "inactive, end it"
            warning. */}
        {status === STATUS.SCHEDULED && (
          <Popup
            trigger={(
              <Icon
                name='clock outline'
                color={STATUS_COLOR[STATUS.SCHEDULED]}
                style={{ marginLeft: '0.4em' }}
                data-testid={`default-coverage-master-scheduled-${id}`}
              />
            )}
            content={SCHEDULED_GUIDANCE}
            wide='very'
          />
        )}
        {status === STATUS.NOT_RESOLVING && (
          <Popup
            trigger={(
              <Icon
                name='warning sign'
                color={STATUS_COLOR[STATUS.NOT_RESOLVING]}
                style={{ marginLeft: '0.4em' }}
                data-testid={`default-coverage-master-warning-${id}`}
              />
            )}
            content={NOT_RESOLVING_GUIDANCE}
            wide='very'
          />
        )}
      </Table.Cell>
      <Table.Cell collapsing>
        {rowMenuOptions.length > 0 && (
          <Dropdown
            text='Actions'
            options={rowMenuOptions}
            onChange={handleActionChange}
            selectOnBlur={false}
            value={null}
            data-testid={`default-coverage-master-actions-${id}`}
          />
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
